var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    fill: "#374255"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2v2h10V2zm4 4v2H0v2h4v2h2V6zm14 4V8H8v2zm-6-4h2V4h4V2h-4V0h-2z"
  })));
};
export default SvgFilter;